import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { GROUP_VISIBILITY } from '../constants/learning-cards';

function GroupCard({ group, cardCount }) {
    const formattedDate = group.createdAt
        ? formatDistanceToNow(new Date(group.createdAt), { addSuffix: true })
        : 'Unknown date';

    return (
        <Link
            to={`/learning-cards/groups/${group.id}`}
            className="card mb-3 text-decoration-none text-dark hover-shadow"
        >
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-1">{group.name}</h5>
                    {group.visibility !== GROUP_VISIBILITY.PRIVATE && (
                        <span className={`badge ${group.visibility === GROUP_VISIBILITY.PUBLIC ? 'bg-success' : 'bg-secondary'}`}>
                            {group.visibility === GROUP_VISIBILITY.PUBLIC ? 'Public' : 'Unlisted'}
                        </span>
                    )}
                </div>

                {group.description && (
                    <p className="card-text text-muted small mb-2 text-truncate">
                        {group.description}
                    </p>
                )}

                <div className="d-flex justify-content-between align-items-center mt-2">
                    {/*<span className="badge bg-primary">{cardCount || 0} cards</span>*/}
                    <small className="text-muted">Created {formattedDate}</small>
                </div>
            </div>
        </Link>
    );
}

export default GroupCard;